import { connect } from 'react-redux';
import Login from './login';
import {
  syncUserData,
  signup,
} from '../../store/actions/user.actions';

const mapStateToProps = ({ user }) => ({ user });

const mapDispatchToProps = (dispatch) => ({
  syncUserData: () => dispatch(syncUserData()),
  signup: (data) => dispatch(signup(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);
